import { ARCHIVED_COLUMN, LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Site ID',
    field: 'siteId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Site Name',
    field: 'siteName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Business Client',
    field: 'businessClientName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Contact',
    field: 'contactName',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Contact Number',
    field: 'contactNumber',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  {
    headerName: 'People on Site',
    field: 'numCurrentVisitors',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];

export const siteAssetColumns = [
  {
    headerName: 'Category',
    field: 'category',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
    cellRenderer: 'activityComponent',
    cellRendererParams: {
      displayType: 'icon',
    },
  },
  {
    headerName: 'Type ID',
    field: 'assetTypeId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Type',
    field: 'assetTypeName',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Asset ID',
    field: 'assetId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Name',
    field: 'name',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
];
export const siteUserColumns = [
  { headerName: 'Name', field: 'name', width: LIST_WIDTH.HUMAN_NAME },
  {
    headerName: 'Phone',
    field: 'phone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  { headerName: 'Email', field: 'email', width: LIST_WIDTH.xl },
];
